import { PLAPP, plAppConfig } from "../config/plAppConfig";
import { ucFirst } from "./globalUtils";

const getAppUrl = (
    appKey: string,
    plAppConfig: PLAPP[],
    isLocalhost: boolean
): [string, string] => {
    const app = plAppConfig.find(app => app.key === appKey);

    const appUrl = isLocalhost
        ? `http://localhost:${app?.port}`
        : `https://${app?.key}.parkinglap.com`;

    const appApiUrl = isLocalhost
        ? `http://localhost:${app?.apiPort}`
        : `https://${app?.key}api.parkinglap.com`;

    return [appUrl, appApiUrl];
};
export const getAppUrls = (
    plAppConfig: PLAPP[],
    isLocalhost: boolean,
    selectedApp: PLAPP = plAppConfig[0]
  ): Record<string, string | boolean> => {
    const appKeys = plAppConfig.map(app => app.key || '');
    const urls: Record<string, string | boolean> = {};
  
    appKeys.forEach((key) => {
      const [appUrl, appApiUrl] = getAppUrl(key, plAppConfig, isLocalhost);
      urls[`${key}Url`] = appUrl;
      urls[`${key}ApiUrl`] = appApiUrl;
      urls[`is${ucFirst(key)}`] = selectedApp.key === key;
    });
  
    return urls || {};
  };

export const getAppUrlInfo = (): any=> {
    const currentUrl = window.location.href;
    const isLocalhost = currentUrl.includes('localhost');

    const selectedApp: PLAPP = plAppConfig.find(app =>
        isLocalhost
            ? currentUrl.includes(`:${app.port}`)
            : currentUrl.includes(app.key)
    ) || plAppConfig[0];

    /* const accountsApp = plAppConfig.find(app => app.key === 'accounts');

    const accountsUrl = isLocalhost
        ? `http://localhost:${accountsApp?.port}`
        : `https://${accountsApp?.key}.parkinglap.com`;

    const accountsApiUrl = isLocalhost
        ? `http://localhost:${accountsApp?.apiPort}`
        : `https://${accountsApp?.key}api.parkinglap.com`; */
    const appUrls = getAppUrls(plAppConfig, isLocalhost, selectedApp);
    console.log('App URLs:', appUrls);

    if (selectedApp) {
        selectedApp.url = isLocalhost
            ? `http://localhost:${selectedApp.port}`
            : `https://${selectedApp.key}.parkinglap.com`;

        selectedApp.apiUrl = isLocalhost
            ? `http://localhost:${selectedApp.apiPort}`
            : `https://${selectedApp.key}api.parkinglap.com`;
    }
    //console.log('App URL Info:', selectedApp)
    return {
        isLocalhost,
        currentUrl,
        ...appUrls,
        ...selectedApp
    };
};
